import React from "react";

const Table = ({ columns = [], rows = [], onRowClick }) => {
  const gridTemplate =
    columns.length === 0
      ? "1fr"
      : columns.map((col) => col.width || "1fr").join(" ");
  return (
    <div className="table">
      <div className="table-head" style={{ "--cols": gridTemplate }}>
        {columns.map((col) => (
            <div
              key={col.key}
              className={`table-cell table-cell-head${
                col.headerClassName ? ` ${col.headerClassName}` : ""
              }`}
              title={col.label}
            >
              {col.label}
            </div>
        ))}
      </div>
      {rows.map((row, idx) => (
        <div
          key={idx}
          className={`table-row${onRowClick ? " table-row-clickable" : ""}`}
          style={{ "--cols": gridTemplate }}
          onClick={onRowClick ? () => onRowClick(row) : undefined}
        >
          {columns.map((col) => (
            <div
              key={col.key}
              className={`table-cell${col.className ? ` ${col.className}` : ""}`}
              title={
                typeof col.render === "function" ? undefined : row[col.key]
              }
            >
              {col.render ? col.render(row) : row[col.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Table;
